import { MarketingBannerVariant } from "@/api/backofficeRest/generated/model"
import { IBannerGroup } from "@/models/alertsBanners/alertsBanners.types"

export const VARIANT_NOTES: Partial<Record<MarketingBannerVariant, string>> = {
  [MarketingBannerVariant.PRICE_CHANGE]:
    "Shown instead of the normal copy from the 15th to the end of March, June, September and December.",
  [MarketingBannerVariant.PROMOTIONAL]:
    "Shown only between promotion dates set in code.",
}

export const orderNotes = (group: IBannerGroup): string[] =>
  group.isAlwaysShown
    ? ["Shown to almost every customer — anything below it rarely shows."]
    : []

export const bannerNotes = (group: IBannerGroup): string[] => [
  ...orderNotes(group),
  ...(group.isFlagControlled
    ? ["Also controlled by a feature flag — ask Engineering to change it."]
    : []),
]
